import React from "react";
import { Doughnut } from "react-chartjs-2";
import {
  emptyDoughnutPlugin,
  ChartDatasetLabelsPlugin,
} from "./chartJsPlugins";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  emptyDoughnutPlugin,
  ChartDatasetLabelsPlugin
);

function DutyAgingDoughnetChart({ data }) {
  const getSumOfDutyValues = () => {
    let ageLt90Sum =
      data?.ageLt90?.netCidAmount ??
      0 + data?.ageLt90?.netEidAmount ??
      0 + data?.ageLt90?.netPalAmount ??
      0 + data?.ageLt90?.netSslAmount ??
      0;

    let age90To180Sum =
      data?.age90To180?.netCidAmount ??
      0 + data?.age90To180?.netEidAmount ??
      0 + data?.age90To180?.netPalAmount ??
      0 + data?.age90To180?.netSslAmount ??
      0;

    let age180To270Sum =
      data?.age180To270?.netCidAmount ??
      0 + data?.age180To270?.netEidAmount ??
      0 + data?.age180To270?.netPalAmount ??
      0 + data?.age180To270?.netSslAmount ??
      0;

    let age270To360Sum =
      data?.age270To360?.netCidAmount ??
      0 + data?.age270To360?.netEidAmount ??
      0 + data?.age270To360?.netPalAmount ??
      0 + data?.age270To360?.netSslAmount ??
      0;

    let ageGt360Sum =
      data?.ageGt360?.netCidAmount ??
      0 + data?.ageGt360?.netEidAmount ??
      0 + data?.ageGt360?.netPalAmount ??
      0 + data?.ageGt360?.netSslAmount ??
      0;

    return [
      ageLt90Sum,
      age90To180Sum,
      age180To270Sum,
      age270To360Sum,
      ageGt360Sum,
    ];
  };

  const chartData = {
    labels: [
      "0-3 Months",
      "3-6 Months",
      "6-9 Months",
      "9-12 Months",
      "> 12 Months",
    ],
    datasets: [
      {
        label: "Total",
        //data: getSumOfDutyValues(),
        data: [50, 60, 80, 100, 120],
        backgroundColor: [
          "rgb(61, 244, 5)",
          "rgb(54, 162, 235)",
          "rgb(133, 110, 239)",
          "rgb(255, 205, 86)",
          "rgb(255, 99, 132)",
        ],
      },
      {
        label: "CID",
        // data: [
        //   data?.ageLt90?.netCidAmount,
        //   data?.age90To180?.netCidAmount,
        //   data?.age180To270?.netCidAmount,
        //   data?.age270To360?.netCidAmount,
        //   data?.ageGt360?.netCidAmount,
        // ],
        data: [10, 20, 30, 40, 50],
        backgroundColor: [
          "rgb(61, 244, 5)",
          "rgb(54, 162, 235)",
          "rgb(133, 110, 239)",
          "rgb(255, 205, 86)",
          "rgb(255, 99, 132)",
        ],
      },
      {
        label: "EID",
        // data: [
        //   data?.ageLt90?.netEidAmount,
        //   data?.age90To180?.netEidAmount,
        //   data?.age180To270?.netEidAmount,
        //   data?.age270To360?.netEidAmount,
        //   data?.ageGt360?.netEidAmount,
        // ],
        data: [20, 40, 60, 80, 100],

        backgroundColor: [
          "rgb(61, 244, 5)",
          "rgb(54, 162, 235)",
          "rgb(133, 110, 239)",
          "rgb(255, 205, 86)",
          "rgb(255, 99, 132)",
        ],
      },
      {
        label: "SSL",
        // data: [
        //   data?.ageLt90?.netSslAmount,
        //   data?.age90To180?.netSslAmount,
        //   data?.age180To270?.netSslAmount,
        //   data?.age270To360?.netSslAmount,
        //   data?.ageGt360?.netSslAmount,
        // ],
        data: [50, 60, 80, 100, 120],
        backgroundColor: [
          "rgb(61, 244, 5)",
          "rgb(54, 162, 235)",
          "rgb(133, 110, 239)",
          "rgb(255, 205, 86)",
          "rgb(255, 99, 132)",
        ],
      },

      {
        label: "PAL",
        // data: [
        //   data?.ageLt90?.netPalAmount,
        //   data?.age90To180?.netPalAmount,
        //   data?.age180To270?.netPalAmount,
        //   data?.age270To360?.netPalAmount,
        //   data?.ageGt360?.netPalAmount,
        // ],
        data: [50, 60, 80, 100, 120],
        backgroundColor: [
          "rgb(61, 244, 5)",
          "rgb(54, 162, 235)",
          "rgb(133, 110, 239)",
          "rgb(255, 205, 86)",
          "rgb(255, 99, 132)",
        ],
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false, // Allows precise control over chart size
    type: "doughnut",
    plugins: {
      legend: {
        labels: {
          color: "white", // Change this to your desired font color
          font: {
            size: 14, // Optional: Change font size
          },
        },
        display: true, // Completely remove legend
      },

      emptyDoughnut: {
        color: "rgba(255, 128, 0, 0.5)",
        width: 2,
        radiusDecrease: 20,
      },
      title: {
        display: true,
        text: "Liability Aging",
        color: "white",

        font: {
          size: 18,
        },
      },
    },
  };

  return (
    <>
      <Doughnut data={chartData} options={chartOptions} />
    </>
  );
}

export default DutyAgingDoughnetChart;
